import PropTypes from 'prop-types';
// @mui
import { Paper, Typography } from '@mui/material';

// ----------------------------------------------------------------------

SearchNotFound.propTypes = {
  query: PropTypes.string,
  sx: PropTypes.object,
};

export default function SearchNotFound({ query, sx, ...other }) {
  return query ? (
    <Paper
      sx={{
        textAlign: 'center',
        ...sx,
      }}
      {...other}
    >
      <Typography variant="h6" paragraph>
        Não encontrado
      </Typography>

      <Typography variant="body2">
        Nenhum resultado encontrado para &nbsp;
        <strong>&quot;{query}&quot;</strong>.
        <br /> Verifique se há erros de digitação ou tente usar palavras completas.
      </Typography>
    </Paper>
  ) : (
    <Typography variant="body2" sx={sx}>
      Por favor, insira palavras-chave para pesquisar.
    </Typography>
  );
}
